const BUTTON_APPEARANCES = ['primary', 'secondary', 'danger', 'link'];
const BUTTON_TYPES = ['button', 'submit', 'reset'];
const BUTTON_ELEMS = ['button', 'a', 'span'];
const BUTTON_DISPLAYS = ['block', 'square', 'stacked'];
const BUTTON_SIZES = ['sm', 'md', 'lg'];

export { BUTTON_APPEARANCES, BUTTON_DISPLAYS, BUTTON_ELEMS, BUTTON_SIZES, BUTTON_TYPES };
